import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page5',
  name: 'pre_close_in_page5',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page5',
      name: 'pre_close_in_page5',
      component: () => import('@/views/pre_settle/pre_close/in/index5'),
      meta: {
        title: 'pre_close_in_page5',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
